import { House, Stack, Plant, CheckSquare, Printer, LinkSimple } from "@phosphor-icons/react";

export const NAV_DEFS = [
  { key: "collection", to: "/", label: "Collection", Icon: House, end: true },
  { key: "batch", to: "/batch", label: "Batch care", Icon: Stack },
  { key: "propagation", to: "/propagation", label: "Propagation", Icon: Plant },
  { key: "tasks", to: "/tasks", label: "Tasks", Icon: CheckSquare },
  { key: "labels", to: "/labels", label: "Labels", Icon: Printer },
];
export const NAV_ROLES = [["admin", "Admins"], ["caregiver", "Caregivers"]];
export const HEADER_BUTTONS = [["acute", "Acute event button"], ["add_plant", "New plant button"], ["theme", "Dark mode toggle"], ["notifications", "Notifications bell"]];

// Saved order first, then any built-in the admin hasn't touched yet.
export const mergeNav = (saved = []) => {
  const byKey = Object.fromEntries(NAV_DEFS.map((d) => [d.key, d]));
  const out = saved.filter((s) => byKey[s.key] || s.url).map((s) => (byKey[s.key]
    ? { ...byKey[s.key], ...s, label: s.label || byKey[s.key].label, defaultLabel: byKey[s.key].label }
    : { ...s, Icon: LinkSimple, custom: true }));
  NAV_DEFS.forEach((d) => { if (!out.some((o) => o.key === d.key)) out.push({ ...d, defaultLabel: d.label, hidden: false, roles: ["admin", "caregiver"] }); });
  return out;
};

export const visibleNav = (saved, user) => mergeNav(saved).filter((l) => !l.hidden
  && (!l.roles || l.roles.includes(user?.role === "admin" ? "admin" : "caregiver"))
  && (l.key !== "labels" || user?.permissions?.manage_labels !== false));

export const isExternal = (url) => /^https?:\/\//.test(url || "");
